const avatar = "_avatar_mcap2_17";
const image = "_image_mcap2_50";
const styles = {
  avatar,
  image,
  "avatar-imageless": "_avatar-imageless_mcap2_61",
  "stacked-avatars": "_stacked-avatars_mcap2_111",
  "clip-path": "_clip-path_mcap2_130"
};
export {
  avatar,
  styles as default,
  image
};
//# sourceMappingURL=Avatar.module.css.js.map
